const Section: React.FC<{ id:string, additionalStyles?: React.CSSProperties, children: React.ReactNode }> = ({ id, additionalStyles, children }) => {
  return (
    <section id={id} style={{ marginBottom: '40px', marginTop: '40px', ...additionalStyles }}>
      {children}
    </section>
  );
}

export default Section;